// extracted by mini-css-extract-plugin
export var quillEditor = "_jy-1";
export var variable = "_jy-0";